import { VerticalNavDivider } from './vertical-nav-divider';
import { VerticalNavHeading } from './vertical-nav-heading';
import { VerticalNavItem } from './vertical-nav-item';
import { VerticalNavList } from './vertical-nav-list';
import { VerticalNavRoot } from './vertical-nav-root';

/**
 * Entry point for VerticalNav.Root, VerticalNav.List VerticalNav.Item
 *   and new subcomponents VerticalNav.Heading, VerticalNav.Divider
 *
 * @since 10.0.0
 */

export const VerticalNav = {
  Root: VerticalNavRoot,
  List: VerticalNavList,
  Item: VerticalNavItem,
  Heading: VerticalNavHeading,
  Divider: VerticalNavDivider,
};
